export const AMERICACHANGETRIP = 'AMERICACHANGETRIP'

export const AMERICAADDADULT = 'AMERICAADDADULT'

export const AMERICAMINUSADULT = 'AMERICAMINUSADULT'

export const AMERICAADDCHILDREN = 'AMERICAADDCHILDREN'

export const AMERICAMINUSCHILDREN = 'AMERICAMINUSCHILDREN'

export const AMERICAPICKDATE = 'AMERICAPICKDATE'

export const AMERICAADDTOCART = 'AMERICAADDTOCART'

export const AMERICAREMOVEFROMCART = 'AMERICAREMOVEFROMCART'

export const AMERICAAIRPORTPICKUP = 'AMERICAAIRPORTPICKUP'

export const AMERICADIFFERENTHOTEL = 'AMERICADIFFERENTHOTEL'

export const AMERICAMORETRIPS = 'AMERICAMORETRIPS'

export const AMERICAREMOVEALL = 'AMERICAREMOVEALL'